import React, { useContext } from "react";
import { slide as Slide } from "react-burger-menu";
import { menuItems, integrationItems, menuItems2 } from "../menu/menuItems";
import classes from "./MobileMenu.module.scss";
import { NavLink, useNavigate, useHref } from "react-router-dom";
import { OrgIdContext, ClientTypes } from "../../store/orgId_context";
import HelpIcon from '@mui/icons-material/Help';
import { Accordion, OverlayTrigger, Tooltip } from "react-bootstrap";
import { UserUIStateContext } from "../../store/userUIStateContext";
import UnpublishedIcon from '@mui/icons-material/Unpublished';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { Sidebar, Menu, MenuItem, SubMenu, menuClasses } from "react-pro-sidebar";
import Logo from "../menu/Logo";


const MobileMenu = () => {
    const { isTransformer , isIntegrator, getRoles, integrationNotFinished, clientType } = useContext(OrgIdContext);
    const {integrationWizardFinished, clientWizardFinished} = useContext(UserUIStateContext);
    const roles = getRoles();
    const navigate = useNavigate();

    let availableBasePaths = ["integration", "administration", "flow", "mycompany"];
    let pathNames = useHref("/")?.replace(/^\/|\/$/g, '').split("/") || [];
    let basePath = pathNames.length > 0 && pathNames[0].toLocaleLowerCase();
    const isBasePath = availableBasePaths.indexOf(basePath) >= 0;

    const drawTreeRec2 = (item, index, depth) => {
        let contains = roles.some(i => item.roles.includes(i)) || item.roles.includes("all");
        if(!contains)
          return;
        let style =  {paddingLeft : (1*depth)+"rem"}
        if(item.hasOwnProperty("children")){
            return (<Accordion.Item className={classes["acc-item"]} eventKey={index}>
                        <Accordion.Header className={classes["acc-head"]} >
                            <span style={style}>{item.icon}{item.itemName}</span>
                        </Accordion.Header>
                        <Accordion.Body className={classes["acc-body"]}>
                            <Accordion flush>
                                {item.children.map((i, ix) => {
                                    return drawTreeRec2(i, ix, depth+1);
                                    })}
                            </Accordion>
                        </Accordion.Body>
                    </Accordion.Item>)
        }else{
            return(<NavLink to={item.url}><div className={classes["acc-button-"+depth]}>{item.icon}{item.itemName}</div></NavLink>)
        }
    }
    const drawTreeRec = (item, index, depth) =>{
        let contains = roles.some(i => item.roles.includes(i)) || item.roles.includes("all");
        if(!contains)
          return;
        
        let color="transparent";
        if(depth===0)
          color = "rgba(255,255,255,.07)";
    
        if(item.hasOwnProperty("children")){
          return(
          <div key={`sidemenu-div-${index}-${item.itemName}`} className={classes["submenu-wrapper"]}>
            <SubMenu label={item.itemName} style={{color : "white"}} icon={item.icon} defaultOpen={isBasePath && depth===0 ? true : false}>
              <div style={{backgroundColor:color}}>
              {item.children.map((i, ix) => {
                return drawTreeRec(i, ix, depth+1);
              })}
              </div>
            </SubMenu>
          </div>
          )
        }else{
          return(
            <MenuItem
              key={`sidemenu-item-${index}`}
              component={<NavLink to={item.url} />}
              style={{color : "white"}} 
              icon={item.icon}
              suffix = {getItemSuffix(item)}
            >
              {item.itemName}
            </MenuItem>
          )
        }
      }
    
      const getItemSuffix = (item) => {
        if(!item)
          return null;
    
        if(integrationWizardFinished !== true && item.url === "/integration-wizard")
          return <UnpublishedIcon style={{fontSize:"1rem"}}/>
        if(clientWizardFinished !== true && item.url === "/client-init")
          return <UnpublishedIcon  style={{fontSize:"1rem"}}/>
        if(integrationWizardFinished ===true && item.url === "/integration-wizard")
        return <CheckCircleIcon style={{fontSize:"1rem", color:"#18b918"}}/>
        if(clientWizardFinished === true && item.url === "/client-init")
          return <CheckCircleIcon  style={{fontSize:"1rem", color:"#18b918"}}/>
        
        return null;
      }
    return (
    <Slide className={classes["mobile-menu"]}>
        <Logo/>
        <Accordion flush>
            {menuItems2.map((item, index) => {
                if(isBasePath && item.basePath !== basePath)
                    return;
                if(!isBasePath && item.onlyForBasePath === true)
                    return;
                let contains = roles.some(i => item.roles.includes(i)) || item.roles.includes("all");
                if(contains)
                    return drawTreeRec2(item, index, 0);
            })}
        </Accordion>
        {/* <Accordion flush>
            <Accordion.Item className={classes["acc-item"]} eventKey="0">
                <Accordion.Header className={classes["acc-head"]}>
                    <HelpIcon/>Accordion Item #1
                </Accordion.Header>
                <Accordion.Body>
                    Lorem ipsum dolor 
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item className={classes["acc-item"]} eventKey="1">
                <Accordion.Header className={classes["acc-head"]}><HelpIcon/>My Company</Accordion.Header>
                <Accordion.Body>
                    <Accordion style={{padding:"0px", margin:"0px"}}>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header className={classes["acc-head"]}>My Company</Accordion.Header>
                        </Accordion.Item>
                        <Accordion.Item eventKey="1">
                            <Accordion.Header className={classes["acc-head"]}>My Company</Accordion.Header>
                        </Accordion.Item>
                        <Accordion.Item eventKey="3">
                            <Accordion.Header className={classes["acc-head"]}>My Company</Accordion.Header>
                        </Accordion.Item>
                    </Accordion>
                </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item className={classes["acc-item"]} eventKey="2">
                <Accordion.Header className={classes["acc-head"]}>Accordion Item #1</Accordion.Header>
                <Accordion.Body>
                    <div>Button</div>
                    <div>Button</div>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion> */}
    </Slide>
    );
};

export default MobileMenu;
